import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './GlobalBanner.css';

const GlobalBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="global-banner">
      <Link to="/subscribe" className="global-banner-text">
        RedboxGlobal Premium — Unlimited access to exclusive insights. Get 30% off with code <strong>RBG30</strong> →
      </Link>
    </div>
  );
};

export default GlobalBanner;
